export default "{\n    \"emptyPlaceholder\": \"Cliquez pour sélectionner un client\",\n    \"searchPlaceholder\": \"Rechercher par nom\"\n}\n"